module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Colin Adams, Abigail Thompson, Joel Hass\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Colin Adams")]), _vm._v(" is Professor of Mathematics at Williams College. He is the author of "), _c('I', [_vm._v("The Knot Book")]), _vm._v(" and winner of the Mathematical Association of America Distinguished Teaching Award for 1998. "), _c('B', [_vm._v("Joel Hass ")]), _vm._v("is Professor of Mathematics at the University of California at Davis, and "), _c('B', [_vm._v("Abigail Thompson")]), _vm._v(" is also Professor of Mathematics at the University of California at Davis. Both have held fellowships from the Sloan Foundation and the National Science Foundation.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/BAFnM4/tc-custom/9781627798853.jpg?1726273345278",
      "alt": "This image is the cover for the book How to Ace Calculus"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("How to Ace Calculus\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Written by three gifted-and funny-teachers, "), _c('i', [_vm._v("How to Ace Calculus ")]), _vm._v("provides humorous and readable explanations of the key topics of calculus without the technical details and fine print that would be found in a more formal text. Capturing the tone of students exchanging ideas among themselves, this unique guide also explains how calculus is taught, how to get the best teachers, what to study, and what is likely to be on exams-all the tricks of the trade that will make learning the material of first-semester calculus a piece of cake. Funny, irreverent, and flexible, "), _c('i', [_vm._v("How to Ace Calculus")]), _vm._v(" shows why learning calculus can be not only a mind-expanding experience but also fantastic fun.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Henry Holt and Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0